import {NgModule} from '@angular/core';
import {ClientServiceProvider} from "./services/client-service/client-service";

@NgModule({
  providers: [
    ClientServiceProvider
  ]
})
export class SellionsClientsModule {}



// WEBPACK FOOTER //
// ./src/modules/clients/clients.module.ts